(function () {
    'use strict';

    angular
        .module('recommendationModule')
        .directive('selectRecommendation', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                modalTitle: '@',
                recomsForObservation: '=?',
                whenSelectedRecommendation: '&'
            },
            controller: ['$scope', '$modal', function ($scope, $modal) {

                $scope.selectRecommendation = function () {

                    // Modal to select risk
                    var modalScope                  = $scope.$new(true);
                    modalScope.modalTitle           = $scope.modalTitle;
                    modalScope.actualRisks          = $scope.risks;
                    modalScope.recomsForObservation = $scope.recomsForObservation;

                    var selectRecommendationModal = $modal({
                        scope: modalScope,
                        template: '/app/shared/grc/recommendation/selectRecommendationModal.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        selectRecommendationModal.$promise.then(selectRecommendationModal.hide);
                    }

                    modalScope.okModal = function () {
                        modalScope.hideModal();
                    }

                    // Add the selected recommendation
                    modalScope.whenSelectRecommendation = function (selectedRecommendation) {
                        $scope.whenSelectedRecommendation({ recommendation: selectedRecommendation });
                        modalScope.okModal();
                    }
                };
            }],
            link: function (scope, elem, attrs) {

                elem.bind('click', function () {
                    scope.selectRecommendation();
                });
            }
        }
    }
})();